import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Alert, Stack, Tab, Typography } from "@mui/material";
import { type FC, type SyntheticEvent, useCallback, useState } from "react";
import { MomentFormCreateFollowUpButton } from "../../../../../modules/moment/component/buttons/moment-form-create-follow-up-button/moment-form-create-follow-up-button";
import type { GroupedMomentAnalyticsData } from "../../../../../modules/stats/server/analytics-service";
import type { UUID } from "../../../../../utils/uuid";
import { AnalyticsSendsTableExpandedInteractionsByLink } from "./expanded-interactions-by-link";
import { AnalyticsSendsTableExpandedInteractionsByPerson } from "./expanded-interactions-by-person";

export const AnalyticsSendsTableExpandedInteractions: FC<{
  to_channel?: boolean;
  momentId: UUID;
  stats: GroupedMomentAnalyticsData["stats"];
  has_dynamic_content: boolean;
}> = ({ stats, momentId, has_dynamic_content, to_channel = false }) => {
  const [tab, setTab] = useState<"person" | "link">("person");
  const handleChange = useCallback((_: SyntheticEvent, newValue: "person" | "link") => {
    setTab(newValue);
  }, []);

  if (to_channel) {
    return (
      <Stack sx={{ px: 2, height: "100%", boxSizing: "border-box" }} direction="column">
        <Stack direction="column" spacing={2} sx={{ my: 2 }}>
          {has_dynamic_content && (
            <Alert severity="info">
              This message contained dynamic content targeting, so recipients might not have all
              seen the same links and buttons.
            </Alert>
          )}
          <AnalyticsSendsTableExpandedInteractionsByLink stats={stats} />
        </Stack>
      </Stack>
    );
  }

  return (
    <Stack sx={{ px: 2, height: "100%", boxSizing: "border-box" }} direction="column">
      <TabContext value={tab}>
        <Stack direction="column" spacing={2} sx={{ my: 2 }}>
          {has_dynamic_content && (
            <Alert severity="info">
              This message contained dynamic content targeting, so recipients might not have all
              seen the same links and buttons.
            </Alert>
          )}
          <Typography variant="body2" color="text.secondary">
            These numbers only count people who received the email.
          </Typography>
          <MomentFormCreateFollowUpButton momentId={momentId} />
          <TabList onChange={handleChange}>
            <Tab label="By person" value="person" />
            <Tab label="By link" value="link" />
          </TabList>
          <TabPanel value="person">
            <AnalyticsSendsTableExpandedInteractionsByPerson stats={stats} />
          </TabPanel>
          <TabPanel value="link">
            <AnalyticsSendsTableExpandedInteractionsByLink stats={stats} />
          </TabPanel>
        </Stack>
      </TabContext>
    </Stack>
  );
};
